// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { ActiveStatus } from './active-status';
import { AddonDocMap } from './addon-doc-map';
import { AddonImage } from './addon-image';
import { AddonStation } from './addon-station';
import { Feature } from './feature';
import { ItemDetailAddon } from './item-detail-addon';
import { JoDetailAddon } from './jo-detail-addon';
import { ManufacturerProductTypeConfigAddon } from './manufacturer-product-type-config-addon';
import { ActiveStatusEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Addon extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Int32 FK account */
  accountId?: number;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** String(512) */
  additionalInfoDescription?: string;
  /** Int32 FK addonStation */
  addonStationId!: number;
  /** String(20) */
  groupingKey!: string;
  /** String(255) */
  instructions?: string;
  /** Boolean */
  isHiddenOnDocs!: boolean;
  /** String(60) */
  mOD_DESCRIPTION?: string;
  /** Int32 FK mismatchFeature */
  mismatchFeatureId?: number;
  /** String(100) */
  nameAndLocation!: string;
  /** Boolean */
  needsAdditionalInfo!: boolean;
  /** FK accountId */
  account!: Account;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** Inv FK addonId */
  addonDocMaps!: AddonDocMap[];
  /** Inv FK addonId */
  addonImages!: AddonImage[];
  /** FK addonStationId */
  addonStation!: AddonStation;
  /** Inv FK addonId */
  itemDetailAddons!: ItemDetailAddon[];
  /** Inv FK addonId */
  joDetailAddons!: JoDetailAddon[];
  /** Inv FK addonId */
  manufacturerProductTypeConfigAddons!: ManufacturerProductTypeConfigAddon[];
  /** FK mismatchFeatureId */
  mismatchFeature!: Feature;
}

